// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 167 ? "detail" : chunkId) + "." + {"167":"04e68789","821":"14521045"}[chunkId] + ".js";
};